// web/src/product-visual.ts
// 产品的视觉标识：缩略图地址 + 两字母产品角标。
//
// 为什么不用 emoji：同一个产品在数据层、产品矩阵页、教程页曾经各有一套 emoji
// （BeatBloom 在数据里是 💥、在详情页是 🥁、ZhengDrift 是 ♙），既不一致也不属于
// 这套单色深色界面。这里统一成「授权前缀 + 产品主色」的方块标记：
// 前缀本来就存在于 shared/products.ts（KR / SF / FD / BB / ZD / HG / WR），
// 颜色由 style.css 里 [data-slug] 定义的 --tone 提供。

import { PRODUCT_META } from "./site-data";

/** 乐器缩略图（480×270，横幅居中裁切后另出的一套小图，见 documentation/网站视觉优化方案.md） */
const PRODUCT_THUMB: Record<string, string> = {
  key_ripple: "/assets/image/products/thumb/key-ripple.jpg",
  string_flow: "/assets/image/products/thumb/string-flow.jpg",
  fret_dance: "/assets/image/products/thumb/fret-dance.jpg",
  beat_bloom: "/assets/image/products/thumb/beat-bloom.jpg",
  zheng_drift: "/assets/image/products/thumb/zheng-drift.jpg",
  harp_glide: "/assets/image/products/thumb/harp-glide.jpg",
  wind_rise: "/assets/image/products/thumb/wind-rise.jpg",
};

export function productThumb(key: string): string {
  return PRODUCT_THUMB[key] ?? PRODUCT_THUMB.key_ripple;
}

/**
 * 产品角标：带主色的小方块，里面是授权前缀（两三个字母）。
 * 元素自带 data-slug，所以 style.css 里的 --tone 会在它身上生效。
 *
 * data-toc-skip-text：角标常被放进 h3，而左栏大纲取标题文字时要跳过它，
 * 否则目录里会变成「KR KeyRipple」（见 toc.ts 的 headingLabel）。
 */
function markHtml(prefix: string, slug: string): string {
  return `<span class="product-mark" data-slug="${slug}" data-toc-skip-text aria-hidden="true">${prefix}</span>`;
}

export function productMark(key: string): string {
  const meta = PRODUCT_META.find((entry) => entry.key === key);
  if (!meta || !meta.prefix) return "";
  return markHtml(meta.prefix, meta.slug);
}

/** 同上，但按页面 slug（key-ripple）查找；不是产品（overview / common / singer）时返回空串 */
export function productMarkBySlug(slug: string): string {
  const meta = PRODUCT_META.find((entry) => entry.slug === slug);
  if (!meta || !meta.prefix) return "";
  return markHtml(meta.prefix, meta.slug);
}
